// OAuth callback landing page.
//
// The API worker redirects here after a successful token exchange:
//   /login/oauth-callback#session_token=...&expires_at=...
// On error the worker redirects to /login?error=... instead, so this page
// only handles the success case and a graceful fallback for missing data.
//
// IMPORTANT: session_token + expires_at are delivered in the URL FRAGMENT
// (after #), not the query, so they are not sent to the server, not
// forwarded as Referer, and not retained in upstream proxy logs. The lazy
// component parses the fragment and immediately scrubs it via
// history.replaceState before any further navigation.
//
// `validateSearch` stays in this eager file so the router can parse URL
// params before deciding which chunk to load. Only `error` is read from
// search params (the worker's error redirect path puts ?error=... in the
// query); the success-path tokens come from window.location.hash and are
// handled entirely in the lazy component.

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/login/oauth-callback")({
  validateSearch: (search: Record<string, unknown>) => ({
    error: typeof search.error === "string" ? search.error : "",
  }),
});
